import {
    AirspaceAuthorisationDto,
    AirspaceCheckCommand,
    PersonDto,
    RpaDto
} from '@flyfreely-portal-ui/flyfreely';

export interface CraftWithError extends RpaDto {
    missingMtow: boolean;
}

export interface ValidationResultMessages {
    rpas: string;
    aerodrome: string;
    activeCells: string;
    height: string;
    towerHours: string;
    airspace: string;
}

export interface TimeValidationResult {
    passStartRange: boolean;
    passEndRange: boolean;
    startRangeString: string;
    endRangeString: string;
    timePastString: string;
}

export interface AuthorisationPersonnelForm {
    rpic: PersonDto;
    crp: PersonDto;
    crpArn: string;
    crpAuthLabel: string;
    rpicArn: string;
    rpicAuthLabel: string;
    rpicPhone: string;
}

export enum CasaFlightProfiles {
    AUTOMATED_GRID = 'AUTOMATED_GRID',
    AUTOMATED_WAYPOINT = 'AUTOMATED_WAYPOINT',
    MANUAL = 'MANUAL'
}

export type AirspaceAuthorisationState =
    | 'CHECKING' // Check in progress
    | 'NO_CHECK' // No checker available
    | 'PASS' // No authorisation required
    | 'AUTO_APPROVAL' // Advise but automatic approval available
    | 'ADVISE_NOT_AVAILABLE' // Advise but there is no approval available
    | 'ADVISE_INCOMPLETE' // Advise the requirements for a check are incomplete
    | 'BLOCKED' // Completely blocked
    | 'APPROVED' // Approved authorisation
    | 'CANCELLED' // Cancelled authorisation
    | 'CLOSED' // Authorisation closed
    | 'UNKNOWN'
    | 'ALTERNATIVE' // Authorisation using alternative URLs, like LAANC
    | 'OPERATION_FAILED' // Check operation failed
    | 'REJECTED' // Request rejected by CAA
    | 'PENDING' // Request is pending a decision by the CAA
    | 'FAILED'
    | 'PROVISIONAL' // Authorisation provisionally approved, but contacting tower on the day is required.
    | 'COMPLETED'
    | 'RESCINDED'
    | 'RESCINDED_AWAITING'
    | 'INVALID'
    | 'DECLARED'
    | 'ERROR'
    | 'TERMINATED';

export interface AlternativeAirspaceAuthorisationRequestCommand {
    missionDetails: AirspaceCheckCommand;
    missionId: number;
    // User ID
    operatorId: number;
    authorisationType: AirspaceAuthorisationDto.AuthorisationType;
    remotePilotPhoneNumber: string;
    remotePilotFirstName: string;
    remotePilotLastName: string;
    remotePilotEmail: string;
    additionalProviderProperties: {
        safetyJustification: string;
    };
}

export interface AuthorisationError {
    code: number;
    message: string;
}
